<script>
import userActivityReportsAPI from 'dashboard/api/userActivityReports';
import FilterSelector from './components/FilterSelector.vue';
import UserActivityTable from './components/overview/UserActivityTable.vue';
import UserActivityDashboard from './components/activity/UserActivityDashboard.vue';
import { getLineChartFilters } from 'dashboard/helper/reportTimeRangeHelper';
import ReportDownloadMenu from './components/ReportDownloadMenu.vue';
import { downloadBinaryFile } from 'dashboard/helper/downloadHelper';

export default {
  name: 'UserActivityReports',
  components: {
    FilterSelector,
    UserActivityTable,
    UserActivityDashboard,
    ReportDownloadMenu,
  },
  data() {
    return {
      pageIndex: 0,
      analytics: {},
      chartDailySummary: [],
      userRankings: [],
      filters: {
        from: null,
        to: null,
        selectedAgents: [],
      },
      uiFlags: {
        isFetching: false,
      },
    };
  },
  mounted() {
    // FilterSelector will handle initial filter load
  },
  methods: {
    async loadReports() {
      this.uiFlags.isFetching = true;
      try {
        const toApiFilters = filters => ({
          since: filters.from
            ? new Date(filters.from * 1000).toISOString().split('T')[0]
            : null,
          until: filters.to
            ? new Date(filters.to * 1000).toISOString().split('T')[0]
            : null,
          user_id:
            filters.selectedAgents.length === 1
              ? filters.selectedAgents[0].id
              : '',
        });

        const apiFilters = toApiFilters(this.filters);
        const chartFilters = toApiFilters(getLineChartFilters(this.filters));
        const analyticsRequest =
          userActivityReportsAPI.getAnalytics(apiFilters);
        const chartRequest =
          chartFilters.since === apiFilters.since
            ? analyticsRequest
            : userActivityReportsAPI.getAnalytics(chartFilters);

        const [analyticsResponse, rankingsResponse, chartResponse] =
          await Promise.all([
            analyticsRequest,
            userActivityReportsAPI.getUserRankings(apiFilters),
            chartRequest,
          ]);

        this.analytics = analyticsResponse.data;
        this.userRankings = rankingsResponse.data.rankings;
        this.chartDailySummary = chartResponse.data.daily_summary || [];
      } catch (error) {
        // Handle error appropriately
      } finally {
        this.uiFlags.isFetching = false;
      }
    },
    onFilterChange(filters) {
      this.filters = filters;
      this.loadReports();
    },
    async onPageNumberChange(newPageIndex) {
      await this.loadReports();
      this.pageIndex = newPageIndex;
    },
    apiFilters() {
      return {
        since: this.filters.from
          ? new Date(this.filters.from * 1000).toISOString().split('T')[0]
          : null,
        until: this.filters.to
          ? new Date(this.filters.to * 1000).toISOString().split('T')[0]
          : null,
        user_id:
          this.filters.selectedAgents.length === 1
            ? this.filters.selectedAgents[0].id
            : '',
      };
    },
    async downloadXlsx() {
      const response = await userActivityReportsAPI.downloadXlsx(
        this.apiFilters()
      );
      return downloadBinaryFile(
        'atividade-dos-usuarios.xlsx',
        response.data,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
    },
  },
};
</script>

<template>
  <div class="flex-1 p-4 overflow-auto">
    <div class="flex flex-col gap-6">
      <!-- Header -->
      <!-- <div class="flex flex-col gap-2">
        <h1 class="text-2xl font-semibold text-slate-800 dark:text-slate-100">
          {{ $t('USER_ACTIVITY_REPORTS.HEADER') }}
        </h1>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          {{ $t('USER_ACTIVITY_REPORTS.DESCRIPTION') }}
        </p>
      </div> -->

      <!-- Filters -->
      <!-- Filters -->
      <FilterSelector
        show-agents-filter
        :show-business-hours-switch="false"
        :show-conversation-direction-filter="false"
        :show-comunicante-campaign-filter="false"
        @filter-change="onFilterChange"
      />
      <ReportDownloadMenu
        class="button--fixed-top"
        :xlsx-handler="downloadXlsx"
      />

      <!-- prettier-ignore -->
      <div>
      <UserActivityDashboard
        :analytics="analytics"
        :daily-summary="chartDailySummary"
        :rankings="userRankings"
        :is-loading="uiFlags.isFetching"
      />

      <!-- User Activity Summary Table -->
      <section
        class="p-5 overflow-hidden bg-white border border-solid rounded-md dark:bg-slate-800 border-slate-75 dark:border-slate-700"
      >
        <h3 class="mb-4 text-lg font-medium text-slate-900 dark:text-slate-50">
          {{ $t('USER_ACTIVITY_REPORTS.AGENT_SUMMARY.HEADER') }}
        </h3>
        <UserActivityTable
          :user-summary="analytics.user_summary || []"
          :is-loading="uiFlags.isFetching"
          :page-index="pageIndex"
          @page-change="onPageNumberChange"
        />
      </section>
      </div>
    </div>
  </div>
</template>
